const translations = {
  "en": {
    "Login to access this.": "Login to access this.",
    "Start Trial": "Start Trial",
    "Your trading deserves better.": "Your trading deserves better."
  },
  "zh-tw": {
    "Login to access this.": "登入以存取此內容。",
    "Start Trial": "開始試用",
    "Your trading deserves better.": "你的交易值得擁有更好的服務。"
  }
};

export default translations;
